import '../../../../styles/globals.css'
import { Box, IconButton, Link, Typography } from '@mui/material'
import { useState } from 'react';
import { Grid } from '@mui/material';

import DeleteIcon from '@mui/icons-material/DeleteForever';
import { useKarmaPoolContext } from '../../../../state/KarmaPoolContext';

export default function DeleteNoteSectionComponent(props) {

    const karmaContext = useKarmaPoolContext();

    function onClickDelete() {
        karmaContext.noteManager.deleteNote(props.note.id);
    }

    if (props.note.userId === karmaContext.local.user.id || karmaContext.local.user.admin) {
        return (
            <>
                <Grid item xs={2} sm={2} sx={{ textAlign: "right", paddingRight: "0.00rem" }}>
                    <Box sx={{ paddingLeft: "1.825rem", marginBottom: "0.325rem" }}>
                        <IconButton onClick={onClickDelete} style={{ textDecoration: "none" }}>
                            <DeleteIcon sx={{ fontSize: "1.25rem", color: "rgba(255,255,255, 0.9)" }} />
                        </IconButton>
                    </Box>

                </Grid>
            </>
        )
    }
    else {
        return (
            <>
                <Grid item xs={2} sm={2} sx={{ textAlign: "right", paddingRight: "0.00rem" }}>

                </Grid>
            </>
        )
    }
}
